import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Desktop } from "./screens/Desktop";
import { Menu } from "./screens/Menu";

const router = createBrowserRouter([
  {
    path: "/*",
    element: <Desktop />,
  },
  {
    path: "/desktop",
    element: <Desktop />,
  },
  {
    path: "/menu",
    element: <Menu />,
  },
]);

export const App = () => {
  return <RouterProvider router={router} />;
};
